import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Upload, Loader2 } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../components/ui/tooltip';
import BulkUploadModal from '../../../components/BulkUploadModal';
import { useBulkUpload, clientsBulkConfig } from '../../../configuration/bulk';

const BulkUploadClientButton = ({ 
  clientId,
  onClientsUploaded, 
  disabled = false, 
  size = "default",
  variant = "outline",
  className = "",
  showIcon = true,
  showText = true,
  tooltipText = "Carga masiva de clientes"
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isUploading, uploadResult, handleBulkUpload } = useBulkUpload(clientId, clientsBulkConfig);

  const handleOpenModal = () => {
    if (!disabled) {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleUploadSuccess = async (items, options) => {
    try {
      const result = await handleBulkUpload(items, options);
      if (result && (result.success || result.successfulItems > 0)) {
        onClientsUploaded?.();
      }
      return result;
    } catch (error) {
      console.error('Error in bulk upload:', error);
      throw error;
    }
  };

  const buttonContent = (
    <>
      {isUploading ? (
        <Loader2 className={`${showText ? 'mr-2' : ''} animate-spin ${size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-6 w-6' : 'h-5 w-5'}`} />
      ) : showIcon ? (
        <Upload className={`${showText ? 'mr-2' : ''} ${size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-6 w-6' : 'h-5 w-5'}`} />
      ) : null}
      {showText && (
        <span>{isUploading ? 'Cargando...' : 'Bulk Upload'}</span>
      )}
    </>
  );

  const ButtonComponent = (
    <Button
      onClick={handleOpenModal}
      disabled={disabled || isUploading}
      size={size}
      variant={variant}
      className={`
        transition-all duration-200 transform hover:scale-105 
        ${variant === 'default' ? 'bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white shadow-lg hover:shadow-xl' : ''}
        ${variant === 'outline' ? 'border-orange-200 text-orange-600 hover:bg-orange-50 hover:border-orange-300 dark:border-orange-700 dark:text-orange-400 dark:hover:bg-orange-900/20' : ''}
        ${disabled ? 'opacity-50 cursor-not-allowed transform-none' : ''}
        ${className}
      `}
    >
      {buttonContent}
    </Button>
  );

  return (
    <>
      {showText || !tooltipText ? (
        ButtonComponent
      ) : (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              {ButtonComponent}
            </TooltipTrigger>
            <TooltipContent>
              <p>{tooltipText}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}

      <BulkUploadModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onUpload={handleUploadSuccess}
        isUploading={isUploading}
        title="Bulk Upload Clients"
        config={clientsBulkConfig}
        uploadResult={uploadResult}
      />
    </>
  );
};

export default BulkUploadClientButton; 